import moment from 'moment';
import {Action} from 'redux';
import {isType} from 'typescript-fsa';
import {Devices} from '../../../api/api';
import * as actions from './actions';
import {DeviceApp, DevicesState} from './types';

const initialState: DevicesState = {
  devices: [],
  pending: false,
  selectedAll: false,
  dateFrom: moment().subtract(1, 'months').toDate(),
  dateTo: new Date(),
  devicesRetrivalFailed: false,
  receivedEmptyList: false,
  success: false,
};

export const devicesReducer = (state = initialState, action: Action): DevicesState => {
  if (isType(action, actions.getDeviceContentAction.started)) {
    return {
      ...state,
      pending: true,
      devicesRetrivalFailed: false,
    };
  }
  if (isType(action, actions.getDeviceContentAction.done)) {
    const items = action.payload.result as DeviceApp[];
    state.devices.forEach((sda) => {
      const appIndex = items.findIndex((da) => da.deviceId === sda.deviceId);
      if (appIndex >= 0) {
        items[appIndex] = {
          ...items[appIndex],
          selected: sda.selected,
        } as DeviceApp;
      }
    });

    return {
      ...state,
      devices: items,
      pending: false,
    };
  }

  if (isType(action, actions.getDeviceContentAction.failed)) {
    return {
      ...state,
      pending: false,
      devicesRetrivalFailed: true,
    };
  }

  if (isType(action, actions.getUserDeviceContentAction.started)) {
    return {
      ...state,
      pending: true,
      devicesRetrivalFailed: false,
      receivedEmptyList: false,
    };
  }

  if (isType(action, actions.getUserDeviceContentAction.done)) {
    const items = action.payload.result as DeviceApp[];

    state.devices.forEach((sda) => {
      const appIndex = items.findIndex((da) => da.deviceId === sda.deviceId);
      if (appIndex >= 0) {
        items[appIndex] = {
          ...items[appIndex],
          selected: sda.selected,
        } as DeviceApp;
      }
    });

    if (items.length < 1) {
      return {
        ...state,
        pending: false,
        devicesRetrivalFailed: false,
        receivedEmptyList: true,
      };
    } else
      return {
        ...state,
        devices: items,
        pending: false,
        devicesRetrivalFailed: false,
      };
  }

  if (isType(action, actions.getUserDeviceContentAction.failed)) {
    return {
      ...state,
      pending: false,
      devicesRetrivalFailed: true,
    };
  }

  if (isType(action, actions.getDevicesAction.started)) {
    return {
      ...state,
      pending: true,
      devicesRetrivalFailed: false,
      receivedEmptyList: false,
    };
  }

  if (isType(action, actions.getDevicesAction.done)) {
    const items = action.payload.result as Devices[];

    if (items.length < 1) {
      return {
        ...state,
        pending: false,
        devicesRetrivalFailed: false,
        receivedEmptyList: true,
      };
    } else
      return {
        ...state,
        adminDevices: items,
        pending: false,
        devicesRetrivalFailed: false,
      };
  }

  if (isType(action, actions.getDevicesAction.failed)) {
    return {
      ...state,
      pending: false,
      devicesRetrivalFailed: true,
    };
  }

  if (isType(action, actions.SetDeviceDatesAction)) {
    return {
      ...state,
      dateFrom: action.payload.dateFrom,
      dateTo: action.payload.dateTo,
    };
  }

  if (isType(action, actions.selectDeviceAction)) {
    const devicesCopy = [...state.devices];
    const index = devicesCopy.findIndex((a) => a.deviceId && a.deviceId === action.payload);
    const objectToModify = {...devicesCopy[index]} as DeviceApp;
    objectToModify.selected = objectToModify.selected ? false : true;
    devicesCopy[index] = objectToModify;
    return {
      ...state,
      devices: devicesCopy,
      selectedAll: false,
    };
  }
  if (isType(action, actions.selectAllAction)) {
    const selectedAll = state.selectedAll ? false : true;
    const devicesCopy = [...state.devices];
    devicesCopy.forEach((d) => {
      d.selected = selectedAll;
    });
    return {
      ...state,
      devices: devicesCopy,
      selectedAll: selectedAll,
    };
  }

  if (isType(action, actions.updateCalibrationFactor.started)) {
    return {
      ...state,
      pending: true,
      success: false,
    };
  }

  if (isType(action, actions.updateCalibrationFactor.done)) {
    let deviceListCopy = [...state.devices];

    if (action.payload.result.deviceId) {
      let deviceIndex = deviceListCopy.findIndex((d) => d.deviceId === action.payload.result.deviceId);

      if (deviceIndex > -1) {
        const newDevice = {...deviceListCopy[deviceIndex]};
        newDevice.calibrationFactor = action.payload.result.calibrationFactor;
        newDevice.lastChanged = action.payload.result.lastChanged;

        deviceListCopy[deviceIndex] = newDevice as DeviceApp;
      }
    }

    return {
      ...state,
      devices: deviceListCopy,
      pending: false,
      success: true,
    };
  }

  if (isType(action, actions.updateCalibrationFactor.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  if (isType(action, actions.updateSpectral.started)) {
    return {
      ...state,
      pending: true,
      success: false,
    };
  }

  if (isType(action, actions.updateSpectral.done)) {
    let deviceListCopy = [...state.devices];

    if (action.payload.result.deviceId) {
      let deviceIndex = deviceListCopy.findIndex((d) => d.deviceId === action.payload.result.deviceId);

      if (deviceIndex > -1) {
        const newDevice = {...deviceListCopy[deviceIndex]};
        newDevice.spectralMeasurement = action.payload.result.spectralMeasurement;
        newDevice.lastChanged = action.payload.result.lastChanged;

        deviceListCopy[deviceIndex] = newDevice as DeviceApp;
      }
    }

    return {
      ...state,
      devices: deviceListCopy,
      pending: false,
      success: true,
    };
  }

  if (isType(action, actions.updateSpectral.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  if (isType(action, actions.updateLabMeasurement.started)) {
    return {
      ...state,
      pending: true,
      success: false,
    };
  }

  if (isType(action, actions.updateLabMeasurement.done)) {
    let deviceListCopy = [...state.devices];

    if (action.payload.result.deviceId) {
      let deviceIndex = deviceListCopy.findIndex((d) => d.deviceId === action.payload.result.deviceId);

      if (deviceIndex > -1) {
        const newDevice = {...deviceListCopy[deviceIndex]};
        newDevice.labMeasurement = action.payload.result.labMeasurement;
        newDevice.lastChanged = action.payload.result.lastChanged;

        deviceListCopy[deviceIndex] = newDevice as DeviceApp;
      }
    }

    return {
      ...state,
      devices: deviceListCopy,
      pending: false,
      success: true,
    };
  }

  if (isType(action, actions.updateLabMeasurement.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  if (isType(action, actions.calibrateDeviceAction.started)) {
    return {
      ...state,
      pending: true,
    };
  }

  if (isType(action, actions.calibrateDeviceAction.done)) {
    let deviceListCopy = [...state.devices];

    if (action.payload.result.deviceId) {
      let deviceIndex = deviceListCopy.findIndex((d) => d.deviceId === action.payload.result.deviceId);

      if (deviceIndex > -1) {
        const newDevice = {...deviceListCopy[deviceIndex]};
        newDevice.calibrationFactor = action.payload.result.calibrationFactor;
        newDevice.lastChanged = action.payload.result.lastChanged;

        deviceListCopy[deviceIndex] = newDevice as DeviceApp;
      }
    }

    return {
      ...state,
      devices: deviceListCopy,
      pending: false,
      success: true,
    };
  }

  if (isType(action, actions.calibrateDeviceAction.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  if (isType(action, actions.updateSpectralMeasurementDateTime.started)) {
    return {
      ...state,
      pending: true,
      success: false,
    };
  }

  if (isType(action, actions.updateSpectralMeasurementDateTime.done)) {
    let deviceListCopy = [...state.devices];

    if (action.payload.result.deviceId) {
      let deviceIndex = deviceListCopy.findIndex((d) => d.deviceId === action.payload.result.deviceId);

      if (deviceIndex > -1) {
        const newDevice = {...deviceListCopy[deviceIndex]};
        newDevice.spectralMeasurementDateTime = action.payload.result.spectralMeasurementDateTime;
        newDevice.lastChanged = action.payload.result.lastChanged;

        deviceListCopy[deviceIndex] = newDevice as DeviceApp;
      }
    }

    return {
      ...state,
      devices: deviceListCopy,
      pending: false,
      success: true,
    };
  }

  if (isType(action, actions.updateSpectralMeasurementDateTime.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  if (isType(action, actions.updateStationId.started)) {
    return {
      ...state,
      pending: true,
      success: false,
    };
  }

  if (isType(action, actions.updateStationId.done)) {
    let deviceListCopy = [...state.devices];

    if (action.payload.result.deviceId) {
      let deviceIndex = deviceListCopy.findIndex((d) => d.deviceId === action.payload.result.deviceId);

      if (deviceIndex > -1) {
        const newDevice = {...deviceListCopy[deviceIndex]};
        newDevice.stationId = action.payload.result.stationId;
        newDevice.lastChanged = action.payload.result.lastChanged;

        deviceListCopy[deviceIndex] = newDevice as DeviceApp;
      }
    }

    return {
      ...state,
      devices: deviceListCopy,
      pending: false,
      success: true,
    };
  }

  if (isType(action, actions.updateStationId.failed)) {
    return {
      ...state,
      pending: false,
    };
  }

  return state;
};
